// extracted by mini-css-extract-plugin
export default {"Wrapper":"Fov3KMlE7osNR74JI44t","Inner":"Wf6h4ZdN2S9XvO6RoMCf"};